import swiper from 'swiper';

var allIndex = $('.top-hero-main-image .swiper-slide:not(.swiper-slide-duplicate)').length - 1;

var heroImageSlider = new swiper ('.js-heroImageSlider', {
  direction: 'horizontal',
  loop: true,
  effect: "fade",
  // effect: "cube",
  // slidesPerView: 5,
  // autoplay: 5e3,
  spaceBetween: 40,
  centeredSlides: true,
  observer: true,
  autoplay: {
    delay: 7000
  },
  breakpoints: {
    768: {
      spaceBetween: 0
    }
  },
  // observeParents: true,
  preloadImages: false,
  slidesPerView: 1,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 4
  },
  pagination: {
    el: '.swiper-heroImage-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '"></span>';
    },
  },

  // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  on: {
    init: function () {
      
      // const allIndex = $('.top-hero-main-image .swiper-slide:not(.swiper-slide-duplicate)').length - 1;
      var $img_src_next = $(".top-hero-main-image .swiper-slide[data-swiper-slide-index=" + (this.realIndex + 1) + "]").find("img").attr('src');

      if($(".top-hero-main-image .swiper-slide[data-swiper-slide-index=" + (this.realIndex + 1) + "]").find("img").attr('src') == undefined) {
        $img_src_next = $(".top-hero-main-image .swiper-slide[data-swiper-slide-index=0]").find("img").attr('src')
      }
      // console.log($img_src_next);

      $('.top-hero-sideImage.is-right img').attr("src", $img_src_next);

      var $img_src_prev = $(".top-hero-main-image .swiper-slide[data-swiper-slide-index=" + (this.realIndex - 1) + "]").find("img").attr('src');

      if($(".top-hero-main-image .swiper-slide[data-swiper-slide-index=" + (this.realIndex - 1) + "]").find("img").attr('src') == undefined) {
        $img_src_prev = $(".top-hero-main-image .swiper-slide[data-swiper-slide-index=" + allIndex + "]").find("img").attr('src')
      }

      $('.top-hero-sideImage.is-left img').attr("src", $img_src_prev);
    },
  }

});



var heroContentSlider = new swiper ('.js-heroContentSlider', {
  direction: 'horizontal',
  loop: true,
  effect: "fade",
  // slidesPerView: 5,
  // autoplay: 5e3,
  spaceBetween: 40,
  // autoplay: {
  //   delay: 7000
  // },
  breakpoints: {
    599: {
      spaceBetween: 0
    }
  },
  // observeParents: true,
  preloadImages: false,
  slidesPerView: 1,

  // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  on: {
    init: function () {
    //   var index = heroImageSlider.activlIndex;
    // // console.log(heroImageSlider.activlIndex);
    // this.slideTo(heroImageSlider.activlIndex);
    }
  }

});




// console.log(allIndex);

heroImageSlider.on('slideChange', function(){
  var index = heroImageSlider.realIndex;
  // console.log("画像" + index);
  // console.log(heroImageSlider.realIndex);
  heroContentSlider.slideTo(heroImageSlider.realIndex + 1);

  // data-swiper-slide-index

  var $img_src_next = $(".top-hero-main-image .swiper-slide[data-swiper-slide-index=" + (heroImageSlider.realIndex + 1) + "]").find("img").attr('src');

  if($(".top-hero-main-image .swiper-slide[data-swiper-slide-index=" + (heroImageSlider.realIndex + 1) + "]").find("img").attr('src') == undefined) {
    $img_src_next = $(".top-hero-main-image .swiper-slide[data-swiper-slide-index=0]").find("img").attr('src')
  }
  // console.log($img_src_next);

  $('.top-hero-sideImage.is-right img').attr("src", $img_src_next);


  var $img_src_prev = $(".top-hero-main-image .swiper-slide[data-swiper-slide-index=" + (heroImageSlider.realIndex - 1) + "]").find("img").attr('src');

  if($(".top-hero-main-image .swiper-slide[data-swiper-slide-index=" + (heroImageSlider.realIndex - 1) + "]").find("img").attr('src') == undefined) {
    $img_src_prev = $(".top-hero-main-image .swiper-slide[data-swiper-slide-index=" + allIndex + "]").find("img").attr('src')
  }

  $('.top-hero-sideImage.is-left img').attr("src", $img_src_prev);

  // $(".top-mobileCategoryNav .swiper-slide").removeClass("is-active");
  // $(".top-mobileCategoryNav .swiper-slide").eq(index).addClass("is-active");
  // setTimeout(function(){
  //   underLine(index);
  //   closePoint = $(".top-categorySlider").offset().top + $(".top-categorySlider").outerHeight();
	// },150);
});

heroContentSlider.on('slideChange', function(){
  var index = heroContentSlider.realIndex;
  // console.log("テキスト" + index);
  heroImageSlider.slideTo(heroContentSlider.realIndex + 1);

  // $(".top-mobileCategoryNav .swiper-slide").removeClass("is-active");
  // $(".top-mobileCategoryNav .swiper-slide").eq(index).addClass("is-active");
  // setTimeout(function(){
  //   underLine(index);
  //   closePoint = $(".top-categorySlider").offset().top + $(".top-categorySlider").outerHeight();
	// },150);
});
